import { render } from "./getDonations.vue?vue&type=template&id=2bd7abdd&scoped=true"
import script from "./getDonations.vue?vue&type=script&lang=js"
export * from "./getDonations.vue?vue&type=script&lang=js"

import "./getDonations.vue?vue&type=style&index=0&id=2bd7abdd&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Documents/personal/freelance-sabdulla/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd7abdd"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QPopupProxy,QDate,QBtn,QTable,QTd,QDialog,QCardSection});qInstall(script, 'directives', {ClosePopup});
